import { render, staticRenderFns } from "./TableauGestion.vue?vue&type=template&id=b7bc8f06&"
import script from "./TableauGestion.vue?vue&type=script&lang=js&"
export * from "./TableauGestion.vue?vue&type=script&lang=js&"
import style0 from "./TableauGestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports